import React, { useCallback, useEffect, useState } from "react";
import {  Outlet, useLocation, useNavigate } from "react-router-dom";
import { Navbar, SideBar } from "./Layouts/MainPage";
import { SidebarItem } from "./Layouts/MainPage/SideBar";
import { useTranslation } from "react-i18next";
import { GetAccess, GetDashboardRole, GetMultipleAccess } from "./Components/Utils/roles";
import { BookOpenCheck, ClipboardCheck, Contact, FireExtinguisher, LayoutDashboard, LayoutList, ListTodo, Mails, ReceiptText, ScrollText, SquareKanban, SquareLibrary, Users } from "lucide-react";

const App = () => {
  const {t} = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
 

      const handleKeyPress = useCallback((event) => {
      if(event.key === "Escape") {
        navigate(-1);
      }
    }, []);
  
    useEffect(() => {
        document.addEventListener('keydown', handleKeyPress);
    return () => {
        document.removeEventListener('keydown', handleKeyPress);
      };
    }, [handleKeyPress]);


  function isActiveFun(x){
    let actualPath = location.pathname.split("/")[1]

    console.log("path",location.pathname.split("/"));
    
    let linkPath = ""
    if(x?.hasSubMenu){
      if(x?.subMenu){
         let y = x.subMenu[0].link;
         let z = y.split("/")[0]
         linkPath = z
      }
    }else{
      linkPath = x?.link;
    }
    console.log("link path",linkPath.includes(actualPath));
    
    if(linkPath.includes(actualPath)) {
      return true;
    }else{
      return false;
    }
  }


const navItem = [
    {
      icon: <LayoutDashboard size={16} />,
      title: "Dashboard",
      hasSubMenu: false,
      hasAccess:true,
      link: GetDashboardRole("")?"/dashboard":GetDashboardRole("sales")?`/dashboard/sales`:GetDashboardRole("procurement")?`/dashboard/procurement`:GetDashboardRole("store")?`/dashboard/stores`:`/dashboard`,
    },
    
    {
      link:GetAccess("survey_report_view")?`/client-management/survey-report`:GetAccess("equipments_view")?`/client-management/equiments`:GetAccess("contracts_view")?`/client-management/contracts`:"#" ,
      icon: (
        <>
          <Users size={16} />
        </>
      ),
      title: "Client Management",
      access: GetAccess("client_management_module"),
      hasSubMenu: false,
      subMenu: [],
    },
   
   
    {
      link:GetAccess("calender_view")?`/inspection/calender`:GetAccess("schedule_view")?`/inspection/schedule`:"#" ,
      icon: (
        <>
          <ClipboardCheck size={16} />
        </>
      ),
      title: "Inspection",
      access: GetAccess("inspection_module"),
      hasSubMenu: false,
    },
    // {
    //   link: GetAccess("schedules_view")?`/testingAndcommisioning/schedules`:"#",
    //   icon: (
    //     <>
    //       <BookOpenCheck size={16} />
    //     </>
    //   ),
    //   title: "Commissioning",
    //   access: GetAccess("testing_and_commisioning_module"),
    //   hasSubMenu: false,
    //   subMenu: [],
    // },

    {
      icon: 
      <>
      <FireExtinguisher size={16} />
      </>,
       link:GetAccess("fire_extinguisher_view")?`/collectionAndreturn/fireExtinguisher`:GetAccess("fire_suppression_view")?`/collectionAndreturn/fireSuppression`:"#",
      title: "Refilling",
      hasAccess:["fire_extinguisher_view,fire_suppression_view"],
      hasSubMenu: false,
      subMenu: [
       
      ],
    },
   
    {
      icon: <SquareKanban size={16} />,
         link:GetAccess("client_tickets_view")?`/tickets/client-tickets`:GetAccess("support_tickets_view")?`/tickets/support-tickets`:"#",
      title: "Tickets",
      hasAccess:["client_tickets_view","support_tickets_view"],
      hasSubMenu: false,
      subMenu: [
       
      ],
    },

    {
      link: GetAccess("invoice_outgoing_view")?`/invoice/invoice-outgoing`:"#",
      icon: (
        <>
          <ReceiptText size={16} />
        </>
      ),
      title: "Invoice",
      access: GetAccess("Invoice_module"),
      hasSubMenu: false,
      subMenu: [],
    },
   
    // {
    //   icon: <ListTodo size={16} />,
    //     link:GetAccess("tasks_view")?`/tasks`:"#",

    //   title: "Tasks",
    //   hasAccess:["task_view"],
    //   hasSubMenu: false,
    //   subMenu: [
       
    //   ],
    // },
   
    // {
    //   icon: <SquareLibrary size={16} />,
    //   title: "Forms",
    //      link:GetAccess("forms_view")?`/forms`:"#",

    //   hasAccess:["forms_view"],
    //   hasSubMenu: false,
    //   subMenu: [
    //          ],
    // },
    // {
    //   link:GetAccess("report_view")?`/report`:"#", 
    //   icon: (
    //     <>
    //     <ScrollText size={16} />
    //     </>
    //   ),
    //   title: "Report",
    //   access: GetAccess("report_module"),
    //   hasSubMenu: false,
    //   subMenu: [],
      
    // },
    // {
    //      link:GetAccess("email_sent_view")?`/email/email-sent`:"#",
    
    //   icon: <Mails size={16} />,
    //   title: "E-mail",
    //   hasAccess:["email_sent_view"],
    //   hasSubMenu: false,
      
    //   subMenu: [
       
    //   ],
    // },
   
    // {
    //   link:GetAccess("main_contractors_view")?`/contacts/main-contractors`:GetAccess("installers_view")?`/contacts/installers`:GetAccess("suppliers_view")?`/contacts/suppliers`:GetAccess("consultants_view")?`/contacts/consultants`:"#" ,
    //   icon: 
    //   <Contact size={16} />,

    //   title: "Contacts",
    //   hasAccess:["main_contractors_view","installers_view","suppliers_view","consultants_view"],
    //   hasSubMenu: false,
    // },
  ];

  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className=" w-full h-screen bg-slate-100 flex justify-start items-center overflow-hidden">
      <div className=" hidden w-16 z-[997] lg:block">
      {/* <div
      className={`h-screen bg-gray-900 text-white transition-all duration-300 ${
        isHovered ? "w-64" : "w-16"
      } fixed left-0 top-0 flex flex-col p-2`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="flex flex-col space-y-4 mt-4">
        <SidebarItems icon={"H"} label="Home" isHovered={isHovered} />
        <SidebarItems icon={"U"} label="Profile" isHovered={isHovered} />
        <SidebarItems icon={"S"} label="Settings" isHovered={isHovered} />
      </div>
    </div> */}
      <SideBar>
        {navItem && 
          navItem.map((item,idx) => {
            
            return (
              <>
              {
                (item?.hasAccess == true||GetMultipleAccess(item?.hasAccess||[]) )&&(<SidebarItem
                    icon={item?.icon}
                    text={t(item?.title)}
                    hasSubMenu={item?.hasSubMenu}
                    subItem={item?.subMenu}
                    link={item?.link}
                    active={isActiveFun(item)}
                    key={idx}
                  />
                )
              }
              </>
            );
          })}
      </SideBar>
      </div>
      <div className=" w-full h-[100vh]  ">
        <div className=" w-full h-[59px] bg-white z-50 shadow-lg">
          <Navbar />
        </div>
        <div className=" w-full h-[calc(100vh-77px)]  overflow-y-auto">
          <Outlet />
        </div>
       
      </div>
    </div>
  );
};

export default App;


function SidebarItems({ icon, label, isHovered }){
  return (
    <div className="flex items-center space-x-4 p-2 rounded-lg hover:bg-gray-800 cursor-pointer">
      <span className="text-xl">{icon}</span>
      {isHovered && <span className="text-sm transition-opacity">{label}</span>}
    </div>
  );
};
